import { Select as AntSelect } from 'antd';
import { CURRENCIES } from '@shared/lib/currencies';

interface CurrencySelectProps {
  value: string;
  onChange: (currency: string) => void;
  id?: string;
  invalid?: boolean;
  className?: string;
}

export function CurrencySelect({ value, onChange, id, invalid, className }: CurrencySelectProps) {
  return (
    <AntSelect
      id={id}
      value={value}
      status={invalid ? 'error' : undefined}
      className={className}
      style={{ width: 120 }}
      onChange={(v) => onChange(v)}
      options={CURRENCIES.map((c) => ({ value: c, label: c }))}
    />
  );
}
